import ProductDetail from 'routes/Products/ProductDetail';
import ProductList from 'routes/Products/ProductList';

const productRoutes = [
  {
    path: 'products/list',
    element: <ProductList />,
  },
  {
    path: 'products/:productId',
    element: <ProductDetail />,
  },
];

export default productRoutes;
